import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  standalone: true,
})
export class PageNotFoundComponent implements OnInit {
  failedUrl = '';
  errorMessage = '';
  errorDetails = '';

  constructor(private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    const nav = window.history.state ?? {};
    this.failedUrl = nav.failedUrl ?? '';
    this.errorMessage = nav.errorMessage ?? '';
    this.errorDetails = nav.errorDetails ?? '';

    this.activatedRoute.queryParamMap.subscribe((params) => {
      this.failedUrl = this.failedUrl || params.get('failedUrl') || '';
      this.errorMessage = this.errorMessage || params.get('errorMessage') || params.get('source') || '';
      this.loadFromStorageIfMissing();
    });

    this.loadFromStorageIfMissing();
  }

  private loadFromStorageIfMissing(): void {
    if (this.failedUrl && this.errorMessage && this.errorDetails) {
      return;
    }

    const storageValue = sessionStorage.getItem('lastNavigationError');
    if (!storageValue) {
      return;
    }

    try {
      const data = JSON.parse(storageValue) as { failedUrl?: string; errorMessage?: string; errorDetails?: string };
      this.failedUrl = this.failedUrl || data.failedUrl || '';
      this.errorMessage = this.errorMessage || data.errorMessage || '';
      this.errorDetails = this.errorDetails || data.errorDetails || '';
    } catch {
      // deliberate ignore for malformed diagnostics
    }
  }

}
